import Vue from 'vue'
import App from './App.vue'
import router from './router' // Importe o arquivo do roteador
import store from './store';
import './assets/theme.css'
import Swal from "sweetalert2";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css'; 
import VueI18n from 'vue-i18n';
import configLanguage from './language/config.js'
import ptMessages from './language/pt.js'
import esMessages from './language/es.js'
import enMessages from './language/en.js'
import frMessages from './language/fr.js'
import geMessages from './language/ge.js'
import hoMessages from './language/ho.js'

Vue.config.productionTip = false

// Vue.use(Swal);
Vue.component('v-select', vSelect);
Vue.prototype.$swal = Swal
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: configLanguage(), // Define o idioma padrão aqui
  messages: {
    pt: ptMessages,
    es: esMessages,
    en: enMessages,
    fr: frMessages,
    ge: geMessages,
    ho: hoMessages,
  },
});

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')